import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FORM_SETTINGS_COMPONENT} from '../../SettingsUtility';

@Component({
    selector: 'smart-form-setting',
    templateUrl: './form-setting.component.html',
    styleUrls: ['./form-setting.component.css']
})
export class FormSettingComponent implements OnInit {
    @Output() eventEmitter = new EventEmitter<string>();


    constructor() {
    }

    ngOnInit() {
    }

    onClickBackButton() {
        this.eventEmitter.emit(FORM_SETTINGS_COMPONENT.name);
    }
}
